import { AxiosResponse } from "axios";
import moment from "moment";

import { ImageData } from "../components/ImagePreviewDialog";
import { TokenDataDTO } from "../models/dto/AuthenticationDTO";
import { CondominiumCoordinatesDTO } from "../models/dto/CondominiumDTO";
import { MedicalCertificateDTO } from "../models/dto/MedicalCertificateDTO";
import { OccurrencesPeriodStatusDTO } from "../models/dto/OccurrencesPeriodStatusDTO";
import { OccurrencesTodayStatusDTO } from "../models/dto/OccurrencesTodayStatusDTO";
import {
  SESSION_STORAGE_USER_FULLNAME,
  SESSION_STORAGE_USER_ID,
} from "../store/actions/authActions";
import { SESSION_STORAGE_REFERENCE } from "../store/actions/condominiumActions";

import { api } from "./api";

export interface MedicalCertificateGETData {
  reference?: number;
  periodFrom?: string;
  periodUntil?: string;
}

export const findMedicalCertificates = async ({
  reference,
  periodFrom,
  periodUntil,
}: MedicalCertificateGETData): Promise<
  AxiosResponse<MedicalCertificateDTO[]>
> => {
  return api.get<MedicalCertificateDTO[]>("/gdp/justificativas", {
    params: {
      ...(reference ? { referencia: reference === 0 ? {} : reference } : {}),
      ...(periodFrom ? { periodoDe: periodFrom } : {}),
      ...(periodUntil ? { periodoAte: periodUntil } : {}),
    },
  });
};

export const getMedicalCertificateImageData = async (
  fileHash: string,
): Promise<ImageData> => {
  const { data, headers } = await api.get(
    `/repositoriodigital/arquivos/${fileHash}`,
    {
      responseType: "arraybuffer",
      headers: { get: { Accept: "application/octet-stream" } },
    },
  );

  const disposition = headers["content-disposition"];
  let filename = "";

  if (disposition && disposition.indexOf("attachment") !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }
  const contentType = filename.split(".")[1];

  return {
    fileBuffer: data,
    contentType,
  };
};

export const getLogDistanceImageData = async (
  fileHash: string,
): Promise<ImageData> => {
  const { data, headers } = await api.get(
    `/gdp/pontos/log-distancia/${fileHash}/download`,
    {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "image/png;image/jpeg;image/jpg",
      },
    },
  );

  const contentType = headers["content-type"].split("/")[1];

  return {
    fileBuffer: data,
    contentType,
  };
};

export const getLogDistanceImageDataLogin = async (
  fileHash: string,
): Promise<ImageData> => {
  const { data, headers } = await api.get(
    `gdp/relatorios/logs-distancia/login/${fileHash}/imagem`,
    {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "image/png;image/jpeg;image/jpg",
      },
    },
  );

  const contentType = headers["content-type"].split("/")[1];

  return {
    fileBuffer: data,
    contentType,
  };
};

export const getEmployeeImg = async (token: string): Promise<any> => {
  return api.get("gdp/funcionarios/foto", {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "image/png;image/jpeg;image/jpg",
      Accept: "*/*",
    },
  });
};

export const getEmployeeImgByHash = async (fileHash: string): Promise<any> => {

  return api.get(`gdp/funcionarios/foto/${fileHash}`, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "image/png;image/jpeg;image/jpg",
      Accept: "*/*",
    },
  });
};

export const findCondominiumCoordinates = async (
  reference: number,
): Promise<AxiosResponse<CondominiumCoordinatesDTO>> => {
  return api.get(`/gdp/coordenadas-referencia/${reference}`);
};

export const findTodayOccurrencesStatus = async (
  reference: number,
): Promise<AxiosResponse<OccurrencesTodayStatusDTO>> => {
  const today = moment().format("YYYY-MM-DD");
  return api.get<OccurrencesTodayStatusDTO>(
    `/gdp/relatorios/status/dia/${reference}`,
    {
      params: {
        periodoDe: today,
        periodoAte: today,
      },
    },
  );
};

export const findPeriodOccurrencesStatus = async (
  reference: number,
  dateFrom: string,
  dateTo: string,
): Promise<AxiosResponse<OccurrencesPeriodStatusDTO>> => {
  return api.get<OccurrencesPeriodStatusDTO>(
    `/gdp/relatorios/status/mes/${reference}`,
    {
      params: {
        periodoDe: dateFrom,
        periodoAte: dateTo,
      },
    },
  );
};

export const saveAccessLogs = async (accessToken: string) => {
  try {
    await api.post<TokenDataDTO>(
      "/gdp/coordenadas-referencia/log-sindico",
      {
        idSindico: sessionStorage.getItem(SESSION_STORAGE_USER_ID),
        nomeSindico: sessionStorage.getItem(SESSION_STORAGE_USER_FULLNAME),
        referencia: sessionStorage.getItem(SESSION_STORAGE_REFERENCE),
      },
      {
        headers: { authorization: `Bearer ${accessToken}` },
      },
    );
  } catch (error) {
    console.log("Falha ao salvar log do síndico!", error);
  }
};
